<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Account Item" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-banking-account-item-form [accountItem]="accountItem" *ngIf="accountItem"></app-banking-account-item-form>
        </form>
      </div>
    </section>
  </div>
</div>


